// extracted by mini-css-extract-plugin
export default {"selectFilterMobile":"CategoriesSelect_selectFilterMobile__yThps","selectFilter":"CategoriesSelect_selectFilter__clviz"};